"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _urlConfig = require("@jusda-tools/url-config");
/* eslint-disable @typescript-eslint/camelcase */

var clientId = window.jusdaBaseConfig.clientId;
var config = {
  clientId: clientId,
  // 获取token
  getTokenUrl: "".concat(_urlConfig.loginSiteUrl, "/token"),
  // cookie过期重定向统一登录
  authUrl: "".concat(_urlConfig.loginSiteUrl, "/pc/login?clientId=").concat(clientId),
  authMobileUrl: "".concat(_urlConfig.loginSiteUrl, "/mobile/login"),
  // 退出登录
  loginOutUrl: "".concat(_urlConfig.loginSiteUrl, "/logout"),
  // 获取用户信息
  getUserInfoUrl: "".concat(_urlConfig.mpApiUrl, "/usercenter-service/authentication/user/detail"),
  // 跨应用鉴权url AuthApplication
  applicationAuthUrl: "".concat(_urlConfig.mpApiUrl, "/usercenter-service/authentication/").concat(clientId, "/have-permission"),
  // 跨应用无权限重定向403 AuthApplication
  url403: _urlConfig.mp_403_url,
  // 移动端跨应用无权限重定向403
  mobileUrl403: "".concat(_urlConfig.mp_domain_prefix, "/h5-personalcenter/#/app403?redirectUrl=").concat(_urlConfig.mp_domain_prefix, "%2Fh5-personalcenter%2F%23%2Fapp403")
  // ...authToolsDefault,
};
var _default = exports["default"] = config;